function LoadingSpinner() {
  return (
    <div className="flex justify-center items-center py-6">
      <div className="h-8 w-8 border-4 border-transparent border-t-[#5288FF] border-l-[#5288FF] rounded-full animate-spin"></div>
    </div>
  );
}

export default LoadingSpinner;